<div class="coach-section-container">
  <div class="coach-section-container-inner">
    <div class="coach-section-content">
      <p style="font-size: 3.8rem; text-transform: uppercase">тренер</p>
      <div class="coach-section-content-text">
        <p style="font-size: 1.5rem">
          Шведский тренер Тэд Сухконен – известный специалист по технике катания и работе с клюшкой и шайбой.
        </p>
        <p style="font-size: 1.5rem">
          В своей тренерской карьере он успел поработать в Федерациях хоккея США и Германии, в сборной Норвегии, в клубах «Амбри-Пиотта» (Швейцария), «Комет», «Лоренског» (оба – Норвегия).
        </p>
      </div>
    </div>
  </div>
</div>
